import React, {Component} from 'react';
import {NavLink, withRouter, Route} from 'react-router-dom';
import lang from '../../Lang/lang.json';
import Icons from '../../../Containers/Icons';
import SpecificTab from './SpecificTab';

class TabConfig extends Component {
  constructor(){
    super();
    this.state = {
      tabs: [],
      users: [],
      vis: [],
      newTab: {
        name: "",
        fullname: ""
      }
    }
  }
  componentDidMount() {
    this.props.changeScreen("TabCnf");
    this.readTabs();
  }
  readTabs = () => {
    const bodyCall = {
      type: "read",
      screen: "tab-conf",
      tkn: this.props.tkn
    }
    fetch(`${this.props.url}api.php`, {
      method: 'post',
      headers: {'Content-type': 'application json'},
      body: JSON.stringify(bodyCall)
    }).then(res => res.json()).then(res => {
      if (res.tkn === false) {
        this.props.history.push('/')
      } else {
        this.setState({tabs: res})
      }
    });
  }
  saveNewTab = () => {
    let bodyCall = {
      type: "create",
      screen: "tab",
      post: {
        name: this.state.newTab.name,
        fullname: this.state.newTab.fullname
      },
      tkn: this.props.tkn
    }
    fetch(`${this.props.url}api.php`, {
      method: 'post',
      headers: {'Content-type': 'application/json'},
      body: JSON.stringify(bodyCall)
    }).then(res => res.json()).then(res => {
      if (res === true) {
        this.readTabs();
        this.props.funct("TabCnf");
        this.props.msg('ok', 'e12');
      }
    })
  }
  clearTabInfo = () => {
    let input = document.querySelectorAll('input');
    Object.keys(input).map(key => {
      input[key].value = "";
      return true;
    })
    this.props.funct("TabCnf");
  }
  newTabData = (e) => {
    let newData = this.state.newTab;
    if (e.target.name === "name") {
      newData.name = e.target.value
    } else {
      newData.fullname = e.target.value
    }
    this.setState({newTab: newData})
  }
  render() {
    let tabs = this.state.tabs;
    let openMod;
    this.props.openMod
    ? openMod = "open"
    : openMod = "closed"

    return (
      <div id="tabconf">
        <Route path='/home/admin/tabs/:id' render={(path) => {
            let tabs = this.state.tabs;
            let slTab = Object.keys(tabs).find(key => {
              return tabs[key].id === path.match.params.id
            })
            tabs = tabs[slTab];
            return (
              <SpecificTab
                openModDel={this.props.openModDel}
                changeScreen={this.props.changeScreen}
                language={this.props.language}
                funct={this.props.funct}
                tab={tabs}
                url={this.props.url}
                tkn={this.props.tkn}
                msg={this.props.msg}
                readTabs={this.readTabs}
              />
            )
        }}/>
        <Route path='/home/admin/tabs' exact render={() => {
          return (
            <div>
              <ul>
              {
                Object.keys(tabs).map(key => {
                  return (
                    <NavLink
                      key={key}
                      to={`/home/admin/tabs/${tabs[key].id}`}
                      onClick={() => this.props.selectTab(tabs[key])}>
                      <li>
                        <span className="tabinfo">
                          <span className="tabName">
                            {tabs[key].name}
                          </span>
                          <span className="arrow gray"><Icons name="arrowThin"/></span>
                          <span className="tabFullname">
                            {tabs[key].fullname}
                          </span>
                        </span>
                        <span className="arrow gray"><Icons name="arrowThin"/></span>
                      </li>
                    </NavLink>
                  )
                })
              }
              </ul>
              <form className={`modal add ${openMod}`}>
                <h3>{lang.TabCnf.title[this.props.language]}</h3>
                <input 
                  autoComplete="Name"
                  name="name"
                  type="text" 
                  placeholder={lang.TabCnf.name[this.props.language]}
                  onChange={this.newTabData}/>
                <input 
                  autoComplete="Full Name"
                  name="fullname"
                  type="text" 
                  placeholder={lang.TabCnf.fullname[this.props.language]}
                  onChange={this.newTabData}/>
                <p>{lang.TabCnf.createInfo[this.props.language]}</p>
                <span className="formButtonsContainer">
                  <span className="formButton ok" onClick={this.saveNewTab}>
                    <Icons name="ok"/>
                  </span>
                  <span className="formButton close" onClick={this.clearTabInfo}>
                    <Icons name="close"/>
                  </span>
                </span>
              </form>
          </div>
          )
        }}/>
      </div>
    )
  }
}

export default withRouter(TabConfig);


// WEBPACK FOOTER //
// ./src/Components/Admin/Tab/TabConf.js